import React, { useState } from "react";
import { Alert } from "reactstrap";
import styled from "styled-components";
import AlertYellow from "../../images/alert-yellow.svg";
import Button from "./Button";

interface IProps {
  message: string;
  color: string;
  btnTxt: string;
  btnOnClick: () => void;
  onClose: () => void;
}

const AlertButtonIcon: React.FC<IProps> = ({
  message,
  color,
  btnTxt,
  btnOnClick: btnFunc,
  onClose,
}) => {
  const [visible, setVisible] = useState(true);

  const onDismiss = () => {
    setVisible(false);
    onClose();
  };

  const getIcon = () => {
    if (color === "warning") return AlertYellow;
  };

  const getAlertClass = () => {
    if (color === "warning") return "warning-alert";
  };

  const getBtnClass = () => {
    if (color === "warning") return "warning-btn";
  };

  return (
    <Alert
      color={color}
      isOpen={visible}
      toggle={onDismiss}
      className={getAlertClass()}
    >
      <div>
        <span>
          <StyledImgIcon src={getIcon()} />
        </span>
        <StyledMessageSpan>{message}</StyledMessageSpan>
        <span>
          <StyledButton
            variant="secondary"
            onClick={btnFunc}
            className={getBtnClass()}
          >
            {btnTxt}
          </StyledButton>
        </span>
      </div>
    </Alert>
  );
};

export default AlertButtonIcon;

const StyledImgIcon = styled.img`
  margin-right: 5px;
  padding-bottom: 5px;
`;

const StyledButton = styled(Button)`
  display: inline-block;
`;

const StyledMessageSpan = styled.span`
  font-weight: 600;
  font-size: 14px;
  /* line-height: 22px; */
  color: #122640;
`;
